import MetaDataValuesList from './MetaDataValuesList';

export default MetaDataValuesList;
